const state = {
  files: []
};

const getters = {
  getFiles: (state) => state.files
};

const mutations = {
  setFiles(state, files) {
    state.files = files;
  },
  clearFiles(state) {
    state.files = [];
  },
  addFile(state, file) {
    state.files.push(file);
  },
  deleteFile(state, index) {
    if (index > -1) {
      state.files.splice(index, 1);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
